import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AboKpiData } from "../services/AboEnrichment/AboEnrichmentAPI.types";

interface PeriodData {
  affAbosFetched: string[];
  affAbosFailed: string[];
  enrichedData: AboKpiData[];
}

interface AboEnrichmentState {
  [reportId: string]: {
    [period: string]: PeriodData;
  };
}

const initialState: AboEnrichmentState = {};

const aboEnrichmentSlice = createSlice({
  name: "aboEnrichment",
  initialState,
  reducers: {
    addFetchedAbos: (
      state,
      action: PayloadAction<{
        reportId: string;
        period: string;
        affAbos: string[];
        enrichedData: AboKpiData[];
      }>,
    ) => {
      const { reportId, period, affAbos, enrichedData } = action.payload;

      if (!state[reportId]) {
        state[reportId] = {};
      }

      if (!state[reportId][period]) {
        state[reportId][period] = {
          affAbosFetched: [],
          affAbosFailed: [],
          enrichedData: [],
        };
      }

      state[reportId][period].affAbosFetched.push(...affAbos);
      state[reportId][period].enrichedData.push(...enrichedData);
    },
    markAbosFailed: (
      state,
      action: PayloadAction<{
        reportId: string;
        period: string;
        affAbos: string[];
      }>,
    ) => {
      const { reportId, period, affAbos } = action.payload;

      if (!state[reportId]) {
        state[reportId] = {};
      }

      if (!state[reportId][period]) {
        state[reportId][period] = {
          affAbosFetched: [],
          affAbosFailed: [],
          enrichedData: [],
        };
      }

      state[reportId][period].affAbosFailed.push(...affAbos);
    },
  },
});

export const { addFetchedAbos, markAbosFailed } = aboEnrichmentSlice.actions;
export default aboEnrichmentSlice.reducer;
